import { render, staticRenderFns } from "./LayoutDimensionItem.vue?vue&type=template&id=0dd08b26&scoped=true"
import script from "./LayoutDimensionItem.vue?vue&type=script&lang=js"
export * from "./LayoutDimensionItem.vue?vue&type=script&lang=js"
import style0 from "./LayoutDimensionItem.vue?vue&type=style&index=0&id=0dd08b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd08b26",
  null
  
)

export default component.exports